import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'SentenceCase',
    standalone: false
})
export class SentenceCasePipe implements PipeTransform {
  transform(value: string | undefined, args?: any): string {
    if (!value || value.length === 0) {
      return '';
    }
    return value[0].toUpperCase() + value.slice(1).toLowerCase();
  }
}
